import React, { useState, useEffect, useRef } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { auth } from './Sign/firebase';

const SubHeader = () => {
    const [isNavbarOpen, setIsNavbarOpen] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);
    const sidebarRef = useRef(null);
    const [user, setUser] = useState(null);
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

    const handleClickOutsideDropdown = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setDropdownOpen(false);
        }
    };

    // 🔥 Close Sidebar When Clicking Outside
    const handleSidebarClickOutside = (event) => {
        if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
            setIsNavbarOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutsideDropdown);

        if (isNavbarOpen) {
            document.addEventListener("mousedown", handleSidebarClickOutside);
        } else {
            document.removeEventListener("mousedown", handleSidebarClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutsideDropdown);
            document.removeEventListener("mousedown", handleSidebarClickOutside);
        };
    }, [isNavbarOpen]);

    const closeMenu = () => setIsNavbarOpen(false);

    const handleLogout = () => {
        auth.signOut().then(() => {
            setIsLoggedIn(false);
            setUser(null);
        });
    };

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((u) => {
            if (u) {
                setIsLoggedIn(true);
                setUser(u);
            } else {
                setIsLoggedIn(false);
                setUser(null);
            }
        });
        return () => unsubscribe();
    }, []);

    return (
        <>
            {/* MAIN HEADER */}
            <div className="container-fluid header">
                <div className="row align-items-center">
                    <div className="col-6 col-md-3">
                        <Link to="/">
                            <img src="/images/codingveda2.png" width="180" alt="LOGO" />
                        </Link>
                    </div>

                    {/* DESKTOP MENU */}
                    <div className="col-md-7 desktop-menu">
                        <Link to="/#tutorials"><button className="Subheader_btn_type_one">TUTORIALS</button></Link>
                        <Link to="/Course"><button className="Subheader_btn_type_two">PRIME</button></Link>
                        <Link to="/Howto"><button className="Subheader_btn_type_one">HOWTO</button></Link>
                        <Link to="/ExerciseTest"><button className="Subheader_btn_type_two exercise_btn">EXERCISE TEST</button></Link>
                        <Link to="/Tools"><button className="Subheader_btn_type_one tools_btn">TOOLS</button></Link>
                        <Link to="/PayNow"><button className="Subheader_btn_type_two tools_btn">PayNow</button></Link>

                        {!isLoggedIn ? (
                            <NavLink to="/signin" className="sign-in">Sign In</NavLink>
                        ) : (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <img
                                    src={user.photoURL}
                                    alt="User Avatar"
                                    style={{ width: "40px", height: "40px", borderRadius: "50%",marginTop:'8px', cursor: "pointer" }}
                                    onClick={toggleDropdown}
                                />

                                {dropdownOpen && (
                                    <div className="dropdown-menus" ref={dropdownRef}>
                                        <div className="row">
                                            <img
                                                src={user.photoURL}
                                                alt="User Avatar"
                                                style={{ width: "90px", borderRadius: "50%" }}
                                            />
                                            <div className="col">
                                                <h6>{user.displayName}</h6>
                                                <h6>{user.email}</h6>
                                            </div>
                                        </div>
                                        <button onClick={handleLogout} className="sign-out">Log Out</button>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>

                    {/* MOBILE MENU ICON */}
                    <div className="col-6 mobile-menu-icon">
                        <div onClick={() => setIsNavbarOpen(!isNavbarOpen)}>
                            {isNavbarOpen ? (
                                <i className="fa fa-times" style={{ fontSize: "28px", marginRight: '472px' }}></i>
                            ) : (
                                <i className="fa fa-bars" style={{ fontSize: "28px", marginRight: '472px' }}></i>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* MOBILE SLIDE MENU */}
            <div ref={sidebarRef} className={`mobile-menu ${isNavbarOpen ? "open" : ""}`}>
                <Link to="/#tutorials" onClick={closeMenu}>Tutorials</Link>
                <Link to="/Course" onClick={closeMenu}>Prime</Link>
                <Link to="/Howto" onClick={closeMenu}>How To</Link>
                <Link to="/ExerciseTest" onClick={closeMenu}>Exercise Test</Link>
                <Link to="/Tools" onClick={closeMenu}>Tools</Link>

                {!isLoggedIn ? (
                    <Link to="/signin" onClick={closeMenu}>Sign In</Link>
                ) : (
                    <button className="logout-btn" onClick={() => { closeMenu(); handleLogout(); }}>
                        Logout
                    </button>
                )}
            </div>
        </>
    );
};

export default SubHeader;
